<ng-container *ngIf="useServiceDetailWrapper; else noWrapper">
    <app-service-detail [location]="pageLocation">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </app-service-detail>
</ng-container>
<ng-template #noWrapper>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
    <div class="row w-100 m-0 position-relative">
        <!--
        <app-variables-tabs
            primarySelectedTab="Tables" class="container-fluid px-5">
        </app-variables-tabs>
        -->
        <div class="col p-0">
            <!--
            <div class="list-header row">
                <div class="col-8">
                    <h1 class="list-header-title">{{"Messages" | translate}}</h1>
                </div>
            </div>
            -->
            <div class="row d-flex align-items-center py-1 list-search-container-zone mb-4">
                <div class="col-md-12 col-xl-8">
                    <div class="list-search-container pr-1">
                        <i class="fas fa-search list-search-icon"></i>
                            <input type="text"
                                (click)="$event.stopPropagation()"
                                (input)="searchTextChanged($event.target.value)"
                                [(ngModel)]="searchValue"
                                placeholder="{{ (messageType === 'MESSAGE' ? 'Search message' : 'Search alert') | translate }}"
                                class="form-control list-search-input flex-grow-1">
                                <i
                                *ngIf="searchValue"
                                (click)="resetListSearch()"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                                aria-hidden="true"
                              ></i>
                                <button class="btn btn-sm btn-primary mr-1"
                                (click)="openEditMessage(false);$event.stopPropagation();"
                                placement="left"
                                aria-hidden="true">{{'New message' | translate}}</button>
                    </div>
                </div>
            </div>

            <!-- Messages in the service -->
            <div class="list-header row">
                <div class="col-8">
                    <span class="list-header-title"><b>{{"Messages used in the service" | translate}}</b> ({{filteredMessages.length}})</span>
                </div>
            </div>
            <div *ngIf="!messages && loadingServiceMessages" class="d-flex justify-content-center my-5">
                <i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
            </div>
            <div *ngIf="!filteredMessages.length && !loadingServiceMessages" class="row">
                <div class="alert alert-info mt-3 col-auto ml-3">
                    {{"No message used in the service yet!" | translate}}
                </div>
            </div>
            <div *ngIf="messages && filteredMessages.length" class="expanded-list unsortable-list row">
                <div class="col-md-12 col-xl-8">
                    <div class="row">
                        <div *ngFor="let message of filteredMessages; let i = index" class="col-12 list-item-container">
                            <div class="d-flex item py-2 {{ i === 0 ? 'first' : '' }}">
                                <div class="col-8 col-lg-9 d-flex align-items-center" (click)="openEditMessage(message);$event.stopPropagation();">
                                    <span>{{message.subject}}</span>
                                </div>
                                <div class="col-1 col-lg-1 text-center" (click)="openMessageUsages(message);$event.stopPropagation();">
                                    <span class="badge badge-light"
                                        tooltip="{{(message.messageRoleStatuses?.length || 0) + (message.messageBots?.length || 0) > 0 ? ('Usages' | translate) : ('None' | translate)}}"
                                        placement="left">{{(message.messageRoleStatuses?.length || 0) + (message.messageBots?.length || 0)}}</span>
                                </div>
                                <div class="col-3 col-lg-2 text-right">
                                    <business-key *ngIf="message?.businessKey" class="ml-auto d-inline-flex align-self-center mr-2"
															[businessKey]="message?.businessKey"
															[businessKeyTooltip]="'Message business key' | translate"
															[extraClass]="'mr-2'"> </business-key>
                                    <confirmation-popover
                                        className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
                                        (onConfirmed)="deleteMessage(message)"></confirmation-popover>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- All other messages -->
            <div class="list-header cursor-pointer row" (click)="showAllmessages = !showAllmessages">
                <div class="col-8">
                    <span class="list-header-title"><b>{{"Messages in the system" | translate}}</b> ({{totalMessages}})</span>
                    <span class="list-header-collapse-toggle">
                        <i class="fa" [ngClass]="{'fa-angle-up': showAllmessages, 'fa-angle-down': !showAllmessages}"></i>
                    </span>
                </div>
            </div>
            <!--
            <div *ngIf="showAllmessages" class="row d-flex align-items-center py-1 list-search-container-zone mb-4">
                <div class="col-md-12 col-xl-8">
                    <div class="list-search-container">
                        <i class="fas fa-search list-search-icon"></i>
                            <input type="text"
                                (click)="$event.stopPropagation()"
                                (input)="searchTextChanged($event.target.value)"
                                [(ngModel)]="searchValue"
                                placeholder="{{ (messageType === 'MESSAGE' ? 'Search message' : 'Search alert') | translate }}"
                                class="form-control list-search-input flex-grow-1">
                                <i
                                *ngIf="searchValue"
                                (click)="resetListSearch()"
                                class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                                aria-hidden="true"
                              ></i>
                                <a class="btn list-search-add btn-dark"
                                (click)="openEditMessage(false);$event.stopPropagation();"
                                placement="left"
                                aria-hidden="true">{{'Add' | translate}}</a>
                    </div>
                </div>
            </div>
            -->
            <div *ngIf="(!allMessages || !allMessages.length) && showAllmessages" class="d-flex justify-content-center my-5">
                <i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
            </div>
            <div *ngIf="allMessages && allMessages.length && showAllmessages" class="expanded-list unsortable-list row">
                <div class="col-md-12 col-xl-8">
                    <div class="row">
                        <div *ngFor="let message of allMessages; let i = index" class="col-12 list-item-container">
                            <div class="d-flex item py-2 {{ i === 0 ? 'first' : '' }}">
                                <div class="col-8 col-lg-9 d-flex align-items-center" (click)="openEditMessage(message);$event.stopPropagation();">
                                    <span>{{message.subject}}</span>
                                </div>
                                <div class="col-1 col-lg-1 text-center" (click)="openMessageUsages(message);$event.stopPropagation();">
                                    <span class="badge badge-light"
                                        tooltip="{{(message.messageRoleStatuses?.length || 0) + (message.messageBots?.length || 0) > 0 ? ('Usages' | translate) : ('None' | translate)}}"
                                        placement="left">{{(message.messageRoleStatuses?.length || 0) + (message.messageBots?.length || 0)}}</span>
                                </div>
                                <div class="col-3 col-lg-2 text-right">
                                    <confirmation-popover
                                        className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
                                        (onConfirmed)="deleteMessage(message)"></confirmation-popover>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showAllmessages" class="row drawer-content-footer m-0">
                <div class="col">
                    <div class="app-pagination">
                        <ul class="pagination">
                            <li class="page-item" *ngIf="page > 2">
                                <a class="page-link" (click)="setPage(1)">
                                    <i class="fal fa-angle-double-left"></i>
                                </a>
                              </li>
                              <li class="page-item" *ngIf="page > 1">
                                <a class="page-link" (click)="setPage((page - 1))">
                                    <i class="fal fa-angle-left"></i>
                                </a>
                            </li>
                            <li
                                *ngFor="let p of pageNumber()"
                                class="page-item"
                                [ngClass]="{'hidden': (p !== page)}">
                                <span class="page-link disabled" disabled>
                                    <b>{{p}}</b> of {{pageNumber()[(pageNumber().length - 1)]}}
                                </span>
                            </li>
                            <li class="page-item" *ngIf="page <= (pageNumber().length-1)">
                                <a class="page-link" (click)="setPage((page + 1))">
                                    <i class="fal fa-angle-right"></i>
                                </a>
                            </li>
                            <li class="page-item" *ngIf="page <= pageNumber()[(pageNumber().length - 2)]">
                                <a class="page-link" (click)="setPage(pageNumber()[(pageNumber().length - 1)])">
                                    <i class="fal fa-angle-double-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <drawer *ngIf="editMessage" [title]="'Edit message'" (saveEvent)="saveEdit()" [isClosed]="!editMessage" (closeEvent)="cancelEdit();" [noContentPadding]="true">
        <message-edit class="drawer-content drawer-direct-content px-4 py-4"
            [serviceId]="serviceId"
            [message]="message"
            [isAlert]="messageType === 'ALERT'"
            (editCancel)="cancelEdit();"
            (formSubmit)="messageWindowSubmitted($event);"></message-edit>
    </drawer>

    <drawer *ngIf="showUsages" [title]="message.name" [showHeaderButtons]="false" [isClosed]="!showUsages" (closeEvent)="cancelEdit();" [noContentPadding]="true">
        <usages class="drawer-content drawer-direct-content px-4 py-4"
            [locations]="['messageBots', 'messageRoleStatuses']"
            [type]="'message'"
            [usages]="message"></usages>
    </drawer>
</ng-template>
